export const openFinanceSidebar = {
  methods: {
    openFinanceSidebar(id) {
      if (id && !this.$route.query.hasOwnProperty('finance')) {
        this.$router.push({
          query: { 
            ...this.$route.query,
            finance: id
          },
        });
        setTimeout(() => {
          this.$root.$emit('bv::toggle::collapse', 'sidebar-right-finance');
        }, 0)
      } else if (id && this.$route.query.hasOwnProperty('finance')) {
        let routeData = this.$router.resolve({
          path: '/finance',
          query: { 
            finance: id
          },
        });
        window.open(routeData.href, '_blank');
      }

      
    },
  }
}